const insertTextAtCursor = (value: string, text: string, start: number, end: number) => {
    const updatedValue =
        value.slice(0, start) +
        text +
        value.slice(end);

    return {
        value: updatedValue,
        cursorPosition: start + text.length,
    };
};

export default insertTextAtCursor;